export default import.meta.ROLLDOWN_FILE_URL_uqbj0e7wxBJ7xARkGbVuFQ